export default __webpack_public_path__ + "static/media/ignitarium.028731d4.svg";